module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"James G. Feleen, PLLC","short_name":"Jim Feleen PLLC","start_url":"/","background_color":"#781010","theme_color":"#781010","display":"minimal-ui","icon":"src/img/feleen-law-logo.jpg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"f70fac778420ab55cc4e526abc39788d"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
